import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

import { navbar } from "../mock";

const Navbar = (props) => {
  const [menuToggled, setMenuToggled] = useState(false);
  const [slide, setSlide] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => {
      setSlide(false);
    }, 0);
    return () => {
      clearTimeout(t);
      setSlide(true);
    };
  }, [props.location.pathname]);

  return (
    <nav className={`nav ${menuToggled ? "menu-toggled" : ""}`}>
      <span
        onClick={() => setMenuToggled(!menuToggled)}
        className="menu-toggler"
      >
        <span>
          <span className="hambuger"></span>
        </span>
      </span>
      <div className="nav-overlay"></div>

      <ul className={`nav-content ${slide ? "move-in" : ""}`}>
        {navbar.map((item, i) => (
          <li key={`nav_item_${i}`} onClick={() => setMenuToggled(false)}>
            <NavLink
              to={item.to}
              exact={Boolean(item.exact)}
              activeClassName="active"
            >
              <span className={`icon ${item.text}-icon`}></span>
              <span className="text">{item.text}</span>
            </NavLink>
          </li>
        ))}
        <li className="theme-toggle-item" onClick={props.toggleTheme}>
          <button className="theme-toggle btn btn-primary">
            <span className="sr-only">Light/Dark theme toggle button</span>
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
